import { useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Device } from "../interfaces/EndpointInterfaces";

interface FriendlyNameDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  device: Device | null;
  onSave: (deviceId: string, friendlyName: string) => void;
}

export default function FriendlyNameDialog({
  open,
  onOpenChange,
  device,
  onSave
}: FriendlyNameDialogProps) {
  const [friendlyName, setFriendlyName] = useState("");

  const handleSave = () => {
    if (device && friendlyName.trim()) {
      onSave(device.id, friendlyName.trim());
      setFriendlyName("");
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    setFriendlyName("");
    onOpenChange(false);
  };

  if (!device) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="friendly-name-dialog">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-slate-800 dark:text-slate-100">
            Update Friendly Name
          </DialogTitle>
        </DialogHeader>

        <div className="py-4 space-y-4">
          <div>
            <p className="mb-1 text-sm font-medium text-slate-700 dark:text-slate-300">
              Host Name: <span className="font-normal">{device.name}</span>
            </p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="friendly-name" className="text-sm font-medium text-blue-600 dark:text-blue-400">
              Friendly Name
            </Label>
            <Input
              id="friendly-name"
              value={friendlyName}
              onChange={(e) => setFriendlyName(e.target.value)}
              placeholder="Enter a new friendly name"
              className="border-blue-300 focus:border-blue-500 focus:ring-blue-500"
              data-testid="input-friendly-name"
            />
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={handleCancel}
            data-testid="button-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={!friendlyName.trim()}
            className="bg-blue-600 hover:bg-blue-700"
            data-testid="button-update"
          >
            Update
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}